import { getGlobalConfig } from './global-config';
import { changeUser, initialize } from '@braze/web-sdk';
import Store from '@monolith/legacy/store/index';

/**
 * This wrapper around the initialize method is only here to provide all
 * the init options in the same place.
 * NOTE: this is only exported so that it can be tested, there is no need to
 * call `initializeBraze` outside of this file.
 */
export function initializeBraze(): boolean {
  const { braze } = getGlobalConfig();
  let isInitialized = false;
  const user = Store.getters.user;
  const canInitialize = !!braze?.api_key && !!braze?.base_url && !!user;

  if (canInitialize) {
    isInitialized = initialize(braze.api_key, {
      baseUrl: braze.base_url,
      enableLogging: false,
    });

    if (isInitialized) {
      changeUser(user.id);
    }
  }

  return isInitialized;
}

export {
  destroy,
  getCachedContentCards,
  hideContentCards,
  openSession,
  requestContentCardsRefresh,
  showContentCards,
  subscribeToContentCardsUpdates,
} from '@braze/web-sdk';
